import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { Subscription } from 'rxjs';
import { HistoricoInterface } from 'src/app/interface/HistoricoInterface';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { RastreadorService } from 'src/app/services/rastreador.service';

@Component({
  selector: 'app-tabla-volatilidad',
  templateUrl: './tabla-volatilidad.component.html',
  styleUrl: './tabla-volatilidad.component.scss'
})
export class TablaVolatilidadComponent implements OnInit, OnDestroy {
  panelOpenState: boolean=false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  public subHistorico = new Subscription;
  public histVolData = new CdkTableVirtualScrollDataSource<HistoricoInterface>;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestion!: CdkVirtualScrollViewport;

  public subHistoricoCompania = new Subscription;
  public histVolCompData = new CdkTableVirtualScrollDataSource<HistoricoInterface>;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportCompania!: CdkVirtualScrollViewport;
  @Input() selectedTab: number =0;
  @Input() isCompania: boolean=false;
  public loadVolatil: boolean;
  public subVolatil: Subscription;
  public loadVolatilCompania: boolean;
  public subVolatilCompania: Subscription;

  tableColumns : TableColmuns []=[
    {id: 'date', name:'Fecha', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'close', name:'Cierre',isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'high', name:'Maximo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'low', name:'Minimo', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'open', name:'Open', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'volume', name:'Volumen', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'condicion1', name:'ATR', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'condicion2', name:'Vol: Historica', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'condicion3', name:'Vol: Relativa', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'condicion4', name:'Desviacion Standard', isShow: true, isDate: false, isNumber: true, isString: false},
  ]


   displayedColumns: string[] = ['date', 'close', 'condicion2', 'condicion3', 'condicion4'];
  filaSeleccionada: any;

  constructor (private _rastreadorservice: RastreadorService){
    this.actualizarViewport();
  }
 ponerseparadoresdemil(value: string | number): string {
    if (value === null || value === undefined) return '';

    // Limpiar entrada si viene como string con separadores/símbolos
    const raw = typeof value === 'string' ? value.replace(/[^\d\-.,]/g, '').replace(/,/g, '.') : String(value);
    const num = Number(raw);
    if (!Number.isFinite(num)) return '';

    // Quitar decimales (truncar)
    const intVal = Math.trunc(num);

    // Formatear con separadores de miles (sin decimales)
    const retorno = new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(intVal);

    // Sufijo según magnitud (usar valor absoluto para decidir)
    const abs = Math.abs(intVal);
    let ext = '';
    if (abs >= 1_000_000_000) ext = 'B';
    else if (abs >= 1_000_000) ext = 'M';
    else if (abs >= 1_000) ext = 'K';

    return ext ? `${retorno} ${ext}` : retorno;
  }
  ngOnDestroy(): void {
    this.subHistorico.unsubscribe();
    this.subHistoricoCompania.unsubscribe();
    this.subVolatil.unsubscribe();
  }
  ngOnInit(): void {
    this.subHistorico = this._rastreadorservice.valRastHistoricoVolatividad.subscribe({
      next: (data: any)=>{
        let combineData = this.flattenArray(data);
        this.histVolData = new CdkTableVirtualScrollDataSource(combineData);
        this.actualizarViewport() 
      }
    });
    this.subHistoricoCompania = this._rastreadorservice.valcompaniaVolatividad$.subscribe({
      next: (data: any)=>{
        let combineData = this.flattenArray(data);
        this.histVolCompData = new CdkTableVirtualScrollDataSource(combineData);
        this.actualizarViewport();
      }
    });
    this.subVolatil = this._rastreadorservice.valLoadVolatil$.subscribe({
      next: (data: any)=>{
        this.loadVolatil = data;
      }
    });
    this.subVolatilCompania = this._rastreadorservice.valloadVolatilCompania$.subscribe({
      next: (data: any)=>{
        this.loadVolatilCompania = data;
      }
    });
  }

  flattenArray(arrayOfArrays: any[]): any[] {
    
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  actualizarViewport() {
    if (this.viewportGestion) {
      this.viewportGestion.checkViewportSize();
      this.viewportGestion.checkViewportSize();
    }
    if (this.viewportCompania) {
      this.viewportCompania.checkViewportSize();
      this.viewportCompania.checkViewportSize();
    }
  }

  selectRow(row: any){
    this.filaSeleccionada=row;
      
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.selectedTab == 1){
      this.actualizarViewport();
    }
  }
toggleColumnVisibility(id: any) {
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
    }
  }
}
